// src/components/NotFoundPage.tsx
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getToken } from 'utils/helpers';

const NotFoundPage: React.FC = () => {
    const navigate = useNavigate();
    const handleGoHome = () => {
        const token = getToken();
        if (token) {
            navigate('/');
        } else {
            navigate('/login');
        }
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100vh"
            textAlign="center"
            bgcolor="background.default"
        >
            <Typography variant="h1" color="error">
                404
            </Typography>
            <Typography variant="h4" gutterBottom>
                Page Not Found
            </Typography>
            <Typography variant="body1" paragraph>
                The page you are looking for does not exist.
            </Typography>
            <Button variant="contained" color="primary" onClick={handleGoHome}>
                Go to Home
            </Button>
        </Box>
    );
};

export default NotFoundPage;
